import React from "react";

const ShareReviewerModal = ({
  isOpen,
  onClose,
  reviewerCode,
  setReviewerCode,
  sharingCode = false,
  onShare,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-3xl w-full max-w-md p-6 shadow-2xl border border-gray-100 animate-in zoom-in-95">
        <div className="flex justify-between items-center mb-4 border-b border-gray-100 pb-3">
          <h3 className="text-lg font-bold text-gray-900">Share Reviewer to Hub</h3>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition"
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <p className="text-xs text-gray-500 mb-5">
          Enter a reviewer code (e.g. NOTE-ABC123) to share study notes, cards, and quizzes with your
          group.
        </p>

        <div className="relative mb-5">
          <input
            type="text"
            value={reviewerCode}
            onChange={(e) => setReviewerCode(e.target.value.toUpperCase())}
            placeholder="e.g. NOTE-AB12CD"
            className="w-full px-4 py-3 pr-20 rounded-xl border border-gray-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none bg-gray-50 focus:bg-white font-mono font-bold text-sm tracking-wider"
            autoFocus
          />
          <button
            type="button"
            onClick={async () => {
              try {
                if (navigator?.clipboard?.readText) {
                  const text = await navigator.clipboard.readText();
                  if (text) setReviewerCode(text.trim().toUpperCase());
                }
              } catch {
                // no-op
              }
            }}
            className="absolute right-2 top-1/2 -translate-y-1/2 px-2.5 py-1.5 rounded-lg text-xs font-bold text-blue-600 bg-blue-50 hover:bg-blue-100 transition"
          >
            Paste
          </button>
        </div>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-3 rounded-xl font-bold text-xs text-gray-600 bg-gray-100 hover:bg-gray-200 transition"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={sharingCode || !reviewerCode.trim()}
            onClick={onShare}
            className="flex-1 py-3 rounded-xl font-bold text-xs text-white bg-blue-600 hover:bg-blue-700 transition shadow-sm disabled:bg-blue-300 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {sharingCode ? (
              <>
                <i className="fa-solid fa-circle-notch fa-spin text-xs"></i>
                <span>Sharing...</span>
              </>
            ) : (
              <span>Share to Group</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareReviewerModal;
